import { chakra } from '@chakra-ui/react'
import React from 'react'

type RecordingPlayerType = {
  src: string
  contact?: any
}
export const RecordingPlayer: React.FC<RecordingPlayerType> = ({ src }) => {
  return (
    <chakra.audio controls={true} autoPlay={false} width="100%" key={src}>
      <source src={src} type="audio/ogg" />
    </chakra.audio>
  )
}
